import { useContext } from 'react'
import { ChatWindowContext, type ChatWindowContextValue } from './ChatWindowContextDef'

/**
 * Hook to access chat window controls.
 * Must be used within a ChatWindowProvider.
 */
export function useChatWindowContext(): ChatWindowContextValue {
  const context = useContext(ChatWindowContext)
  if (!context) {
    throw new Error('useChatWindowContext must be used within a ChatWindowProvider')
  }
  return context
}

/**
 * Optional hook that returns null if used outside provider.
 * Useful for components that may or may not be in the provider tree.
 */
export function useOptionalChatWindow(): ChatWindowContextValue | null {
  return useContext(ChatWindowContext)
}
